export default __webpack_public_path__ + "static/media/long_scrap_of_paper.f91b3bde.png";